export default function PHP_exit() {
  return (
    <div>
      <h1>PHP_exit</h1>
    </div>
  );
}
